import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PetitionExtraHoursPage } from './petition-extra-hours';

@NgModule({
  declarations: [
    PetitionExtraHoursPage,
  ],
  imports: [
    IonicPageModule.forChild(PetitionExtraHoursPage),
  ],
})
export class PetitionExtraHoursPageModule {}



// WEBPACK FOOTER //
// ./src/pages/petition-extra-hours/petition-extra-hours.module.ts